const CURRENT_COLOR = "rgba(34, 197, 94, 1)";
const CURRENT_FILL = "rgba(34, 197, 94, 0.15)";
const LAST_YEAR_COLOR = "rgba(245, 158, 11, 1)";
const LAST_YEAR_FILL = "rgba(245, 158, 11, 0.15)";
const PAYMENT_TYPE_COLORS = {
  cash: "rgba(34, 197, 94, 0.7)",
  card: "rgba(59, 130, 246, 0.7)",
  stripe: "rgba(168, 85, 247, 0.7)",
  bank_transfer: "rgba(245, 158, 11, 0.7)",
  viva: "rgba(6, 182, 212, 0.7)",
};
const DEFAULT_PAYMENT_TYPE_COLOR = "rgba(107, 114, 128, 0.7)";
const AGE_GROUP_COLOR = "rgba(59, 130, 246, 0.7)";

export const withLineChartStyles = (data) => ({
  ...data,
  datasets: data.datasets.map((dataset, index) => {
    const isLastYear = index === 1;
    const color = isLastYear ? LAST_YEAR_COLOR : CURRENT_COLOR;

    return {
      ...dataset,
      borderColor: color,
      backgroundColor: isLastYear ? LAST_YEAR_FILL : CURRENT_FILL,
      pointBackgroundColor: color,
      pointBorderColor: color,
      borderWidth: 2,
      tension: 0.3,
      borderDash: isLastYear ? [6, 6] : undefined,
      fill: true,
    };
  }),
});

export const withPaymentDistributionStyles = (data) => ({
  ...data,
  datasets: data.datasets.map((dataset) => ({
    ...dataset,
    backgroundColor: data.payment_types.map(
      (paymentType) =>
        PAYMENT_TYPE_COLORS[paymentType] || DEFAULT_PAYMENT_TYPE_COLOR
    ),
    borderRadius: 6,
  })),
});

export const withAgeGroupDistributionStyles = (data) => ({
  ...data,
  datasets: data.datasets.map((dataset) => ({
    ...dataset,
    backgroundColor: AGE_GROUP_COLOR,
    borderRadius: 6,
  })),
});
